var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "260.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 260.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120 2988 c-250 -23 -535 -80 -895 -180 -124 -34 -155 -47 -181 -72 l-31 -31 -6 -154 c-10 -232 -8 -807 3 -971 32 -450 143 -718 403 -967 186 -178 605 -450 776 -503 134 -42 222 -22 450 105 641 356 867 632 936 1139 21 153 29 541 20 981 l-7 369 -32 31 c-26 26 -55 38 -171 69 -297 79 -581 134 -905 176 -165 21 -211 22 -360 8z m480 -253 c211 -31 470 -83 640 -128 l125 -33 3 -479 c5 -660 -14 -843 -107 -1041 -113 -241 -342 -436 -786 -670 -155 -82 -180 -83 -303 -19 -321 165 -590 368 -724 545 -67 88 -132 225 -162 340 -46 181 -51 259 -51 810 l0 514 45 13 c139 42 462 117 589 139 306 51 443 53 731 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 2465 c-27 -16 -49 -40 -62 -68 -20 -42 -21 -57 -21 -510 0 -501 1 -507 51 -554 67 -61 157 -66 223 -11 67 55 66 46 66 566 l0 469 -23 43 c-44 84 -152 114 -234 65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 1045 c-77 -27 -126 -110 -111 -189 16 -86 87 -139 178 -134 71 5 119 39 143 103 52 135 -75 269 -210 220z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.319bf6a55881203f46031f9d60b5ca2b.svg";
export { ForwardRef as ReactComponent };